module.exports = __webpack_public_path__ + "img/no_waybill_info.0de6691.jpg";